import api from "./api";
import { BASE_URL2 } from "./auth";

export async function getDocumentLink(docId: string, onFailure: () => void) {
  try {
    const response = await api.get(`${BASE_URL2}/documents/${docId}/link`, {
      timeout: 0,
    });
    return response.data;
  } catch (error) {
    onFailure();
  }
}
